// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { List } from '@mui/material';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { BankUploadDrawerHeader } from '../drawer-header/drawer-header';
import { BankUploadSectionTabs } from '../section-tabs/section-tabs';
import styles from './bank-upload-drawer.module.css';
import { useBankUploadDrawer } from './use-bank-upload-drawer';

export const BankUploadDrawer = defineComponent({
  displayName: 'BankUploadDrawer',
  useSetup: useBankUploadDrawer,
  View: ({ DrawerRenderer, Trigger, drawerTestId, element, showSectionTabs }) => (
    <DrawerRenderer
      Trigger={Trigger}
      anchor="right"
      PaperProps={{
        classes: {
          root: styles['drawer-paper'],
        },
        sx: { height: '100%', maxHeight: '100vh' },
      }}
      data-testid={drawerTestId}
    >
      <List dense disablePadding className={styles['drawer-list']}>
        <BankUploadDrawerHeader />

        <div className={styles['wizard-shell']}>
          {showSectionTabs ? <BankUploadSectionTabs /> : null}
          <div className={styles['wizard-main']}>
            <div className={styles['step-content-scroll']}>{element}</div>
          </div>
        </div>
      </List>
    </DrawerRenderer>
  ),
});
